<template>
  <div>
    <div id="Waves">
      <!-- Header -->
      <div class="header py-7 py-lg-8 pt-lg-9">
        <b-container>
<!--          <b-img id="404img" src="https://i.imgur.com/Tkt1nmt.jpg"></b-img>-->
          <div class="header-body text-center mb-7">
            <b-row class="justify-content-center">
              <b-col xl="5" lg="6" md="8" class="px-5">
                <h1 id="notfound" class="text-lead text-white">The page you were looking for cannot be found.</h1>
                <router-link to="/" class="font-weight-bold text-white mt-5" v-slot="{navigate}">
                  <a @keypress.enter="navigate" @click="navigate" role="link">Back to <u><span class="text-info">Home</span></u></a>
                </router-link>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
  mounted() {
    document.title = '404 - Page Not Found'
  }
};
</script>
